/**
 * 筋特征预览执行处理器。
 */

import { RibFeatureDefinitionModel } from '../../../definition/rib/RibFeatureDefinition';
import type { FeatureEditSession } from '../../../edit/FeatureEditSession';
import { RibFeaturePrototype } from '../../../prototype/rib/RibFeaturePrototype';
import {
    FeaturePreviewExecutionHandler,
    type FeaturePreviewExecutionInput,
    type FeaturePreviewExecutionResult,
} from '../FeaturePreviewExecutionHandler';
import { RibPreviewExecution } from './RibPreviewExecution';

/**
 * 筋特征预览执行处理器。
 */
export class RibPreviewExecutionHandler extends FeaturePreviewExecutionHandler {
    /** 筋预览执行器。 */
    private readonly execution: RibPreviewExecution;

    /**
     * @param execution 筋预览执行器。
     */
    public constructor(execution: RibPreviewExecution) {
        super();
        this.execution = execution;
    }

    /**
     * @inheritdoc
     */
    public supports(input: FeaturePreviewExecutionInput): boolean {
        return input.featureKind === 'rib' && input.definition instanceof RibFeatureDefinitionModel;
    }

    /**
     * @inheritdoc
     * @throws 当预览输入中的定义不是筋特征定义时。
     */
    public async execute(input: FeaturePreviewExecutionInput): Promise<FeaturePreviewExecutionResult> {
        if (!(input.definition instanceof RibFeatureDefinitionModel)) {
            throw new Error('筋预览处理器收到的 definition 类型不正确');
        }

        const prototype = new RibFeaturePrototype({
            featureId: input.featureId ?? `preview:${Date.now()}`,
            definition: input.definition,
            bindings: input.bindings,
            sourceSketchId: null,
        });
        const previewResult = input.session
            ? await this.execution.executeEditPreview(
                input.session as FeatureEditSession<RibFeatureDefinitionModel, RibFeaturePrototype>,
                input.definition,
            )
            : await this.execution.executeCreatePreview(input.definition);
        return {
            meshData: previewResult.meshData,
            prototype,
            draftDefinition: input.definition,
        };
    }
}
